import { DispositiveProvisionDispositionKind } from '@/types/schema';

import { DispositiveProvisionsFormRecipient } from '../../DispositiveProvisionsForm.types';

export function getLastRecipientWithAnythingLeftOverIndex(
  recipients: DispositiveProvisionsFormRecipient[] | null | undefined
): number | null {
  let lastValidIndex: number | null = null;
  recipients?.forEach((recipient, index) => {
    if (isRecipientWithAnythingLeftOver(recipient)) {
      lastValidIndex = index;
    }
  });

  return lastValidIndex;
}

export function isRecipientWithAnythingLeftOver(
  recipient: Pick<
    DispositiveProvisionsFormRecipient,
    | 'dispositionKind_ButtonGroup'
    | 'dispositionKind_Select'
    | 'dispositionPercentage'
  >
): boolean {
  if (
    recipient.dispositionKind_ButtonGroup === 'other' &&
    recipient.dispositionKind_Select ===
      DispositiveProvisionDispositionKind.AnythingLeftOver
  ) {
    return true;
  }

  if (
    recipient.dispositionKind_ButtonGroup ===
      DispositiveProvisionDispositionKind.Percentage &&
    recipient.dispositionPercentage?.eq(100)
  ) {
    return true;
  }

  return false;
}

export function isLastRecipientWithAnythingLeftOver(
  recipients: DispositiveProvisionsFormRecipient[] | null | undefined,
  currentRecipientIndex: number
): boolean {
  const lastRecipientWithAnythingLeftOverIndex =
    getLastRecipientWithAnythingLeftOverIndex(recipients);

  const currentRecipient = recipients?.[currentRecipientIndex];
  if (!currentRecipient) return false;

  if (!isRecipientWithAnythingLeftOver(currentRecipient)) return false;

  return lastRecipientWithAnythingLeftOverIndex === currentRecipientIndex;
}
